import base from './base/index' // 接口域名列表
import axios from '../utils/http' // 导入http中创建的axios实例
import utils from '../utils'
/**
 * 自定义报表
 */
const statement = {
  /**
   * 创建报表
   */
  createUserDefinedStatement(companyId, name) {
    return axios.post(
      base.statement.createUserDefinedStatement,
      utils.postParamsArrayToJsonString({ companyId, name })
    )
  },
  /**
   * 修改报表
   */
  modifyUserDefinedStatement(id, name) {
    return axios.post(
      base.statement.modifyUserDefinedStatement,
      utils.postParamsArrayToJsonString({ id, name })
    )
  },
  /**
   * 删除报表
   */
  deleteUserDefinedStatement(id) {
    return axios.post(
      base.statement.deleteUserDefinedStatement,
      utils.postParamsArrayToJsonString({ id })
    )
  },
  /**
   * 查询报表
   */
  getUserDefinedStatements(companyId) {
    return axios.post(
      base.statement.getUserDefinedStatements,
      utils.postParamsArrayToJsonString({ companyId })
    )
  },
  /**
   * 设置报表格式
   */
  setUserDefinedStatements(statementId, config) {
    return axios.post(
      base.statement.setUserDefinedStatements,
      utils.postParamsArrayToJsonString({ statementId, config })
    )
  },
  /**
   * 获取报表格式
   */
  getUserDefinedStatementConfig(statementId) {
    return axios.post(
      base.statement.getUserDefinedStatementConfig,
      utils.postParamsArrayToJsonString({ statementId })
    )
  },
  /**
   * 生成表格数据
   */
  generateUserDefinedStatementDataDay(statementId, time) {
    return axios.post(
      base.statement.generateUserDefinedStatementDataDay,
      utils.postParamsArrayToJsonString({ statementId, time })
    )
  },
  /**
   * 生成表格数据
   */
  generateUserDefinedStatementDataMonth(statementId, time) {
    return axios.post(
      base.statement.generateUserDefinedStatementDataMonth,
      utils.postParamsArrayToJsonString({ statementId, time })
    )
  },
  /**
   * 生成表格数据
   */
  generateUserDefinedStatementDataYear(statementId, time) {
    return axios.post(
      base.statement.generateUserDefinedStatementDataYear,
      utils.postParamsArrayToJsonString({ statementId, time })
    )
  },
}

export default statement
